import React from "react";
import { Line } from "react-chartjs-2";

const ChartLine = () => {
    const options = {
        responsive: true,
        legend: {
            display: true,
            position: "bottom",
            labels: {
                fontSize: 14,
                fontColor: "#6C757D",
                fontFamily: "Calibri",
            },
        },
        plugins: {
            datalabels: {
                display: false,
                formatter: (value) => {
                    return value + "%";
                },
                color: "#fff",
                font: {
                    size: 9,
                    weight: "bold",
                },
            },
        },
    };

    const data = {
        labels: ["2020", "2021", "2022"],
        datasets: [
            {
                label: "Beriman",
                data: [33, 25, 35, 51, 54, 76],
                fill: false,
                borderColor: "#742774",
            },
        ],
    };

    return (
        <div>
            <Line data={data} options={options} height={300} />
        </div>
    );
};

export default ChartLine;
